module.exports = __webpack_public_path__ + "img/電気回路_1_3_2.12cad707.png";